import { AppUtil } from 'kuaidong-lib'
import { IShareConfig } from 'kuaidong-model'

export function getShareConfig(source_id: string): Promise<IShareConfig> {
  return AppUtil.httpGET(`${process.env.VUE_APP_CRAZYROPE_MANAGE_API}/share_config`, {
    source_id,
  })
}
